import React from 'react'
import { Banner, CategoriesSection } from "../../component/index"
function Home() {
    return (
        <div>
            <Banner />
            <CategoriesSection />
        </div>
    )
}
export default Home;